export const stepViewData = {
  creditNoteWizard: {
    title: "creditNoteWizard.title",
    description: "creditNoteWizard.description",
    width: "1024px",
    contentHeight: "512px",
    showPreviousNext: false,
    steps: [
      {
        title: "creditNoteWizard.step.1.title",
        component: {
          type: "ListView",
          listType: "selectInvoiceList",
          description: "creditNoteWizard.step.1.description"
        }
      },
      {
        title: "creditNoteWizard.step.2.title",
        component: {
          type: "PageView",
          pageType: "creditNoteNewPage",
          options: {
            mode: "new",
            load: true,
            onMount: 'collapse',
            resizeable: true,
          }
         }
      }    ]
  },
  projectInvoiceWizard: {
    title: "projectInvoiceWizard.title",
    description: "projectInvoiceWizard.description",
    width: "1024px",
    contentHeight: "512px",
    showPreviousNext: false,
    steps: [
      {
        title: "projectInvoiceWizard.step.1.title",
        component: {
          type: "ListView",
          listType: "selectProjectTaskList",
          description: "projectInvoiceWizard.step.1.description",
          selectAction: {
            label: "projectInvoiceWizard.step.1.confirm",
            action: "nextStep"
          }
        }
      },
      {
        title: "projectInvoiceWizard.step.2.title",
        component: {
          type: "PageView",
          pageType: "invoiceFromProjectPage",
          options: {
            mode: "new",
            load: false,
            onMount: 'collapse',
            resizeable: true
          }
        }
      }
    ]
  },
  stockReceiptWizard: {
    title: "inventory.receipt.wizard.title",
    description: "inventory.receipt.wizard.description",
    width: "1024px",
    contentHeight: "512px",
    showPreviousNext: false,
    steps: [
      {
        title: "inventory.receipt.wizard.step.1.title",
        component: {
          type: "ListView",
          listType: "selectPurchaseOrderList",
          description: "inventory.receipt.wizard.step.1.description"
        }
      },
      {
        title: "inventory.receipt.wizard.step.2.title",
        component: {
          type: "PageView",
          pageType: "stockReceiptNewPage",
          options: {
            mode: "new",
            load: true,
            onMount: 'collapse',
            resizeable: true,
          }
        }
      }
    ]
  }
}